<ng-container *ngIf="(dashboardDatas$ | async) as dashboardDatas">

  <div *ngIf="dashboardDatas.uxInteractions.sendCard.mode === 'edit'" fxFlex fxLayout="column" class="h-100-p" [formGroup]="fEmailToCard">

    <div fxFlex="auto" class="p-16">

      <mat-form-field fxFlex="auto" class="w-100-p h-100-p">

        <mat-label>Card</mat-label>
        <mat-select formControlName="cardTypeChoosed">
          <mat-select-trigger>
            <div fxLayout fxLayoutAlign="start center">
              <div fxFlex class="tangoCard-picture">
                <img src="{{cardChoosed?.imageUrl}}" alt="{{cardChoosed?.name}}"/>
              </div>
              <span fxFlex class="tangoCard-name">
                {{cardChoosed?.name ? cardChoosed.name : ''}}
              </span>
            </div>
          </mat-select-trigger>

          <mat-option *ngFor="let card of cardList" [value]="card.utid" class="p-4">
            <div fxLayout fxLayoutAlign="start center" class="p-4">
              <img src="{{card && card.imageUrl}}" alt="{{card.name}}" class="tangoCard-picture-list"/>
              <span fxFlex="auto" class="tangoCard-name">{{card.name}} ({{card.currency}})</span>
            </div>
          </mat-option>
        </mat-select>

      </mat-form-field>

      <mat-form-field fxFlex style="margin-top:6px;" class="h-100-p p-8" *ngIf="cardChoosed">
        <mat-label>Card amount</mat-label>
        <input matInput type="number" placeholder="Enter a value" formControlName="amountChoosed">
        <span matSuffix>{{cardChoosed.currency}}</span>
        <button
          [disabled]="cardChoosed.faceValue !== 'none'"
          mat-button *ngIf="fEmailToCard.controls.amountChoosed?.value"
          matSuffix mat-icon-button
          aria-label="Clear" (click)="fEmailToCard.controls.amountChoosed.patchValue('', {emitEvent: false})">
          <mat-icon>close</mat-icon>
        </button>
        <mat-error *ngIf="fEmailToCard.controls.amountChoosed.invalid">Invalid Amount!</mat-error>
      </mat-form-field>

    </div>

    <ng-container *ngIf="cardChoosed">

      <div fxFlex="auto" class="fuse-card" fxLayout="column" id="receipt" style="min-height:200px;" formArrayName="recipients">

        <div fxFlex fxLayout="row" *ngIf="!importMode">
          <div fxFlex="grow">
            <div class="p-16">
              <div class="h1">To: <span *ngIf="formState?.recipients.length > 1">({{formState?.recipients.length}})</span></div>
              <div class="h4 secondary-text">Emails receipient list</div>
            </div>
          </div>
          <div fxFlex="auto" class="p-8">
            <button mat-stroked-button (click)="importMode = true">Import</button>
          </div>
        </div>

        <div fxFlex class="p-8" fxLayout="column" style="overflow: auto;" *ngIf="importMode">
          <div>
            <mat-form-field class="w-100-p">
              <mat-label>Batch import</mat-label>
              <textarea matInput placeholder="Copy/Past eMails here...." [formControl]="fEmailsToImport" style="min-height:100px"></textarea>
            </mat-form-field>
          </div>
          <div fxFlex>
            <span fxFlex="grow"></span>
            <button mat-stroked-button (click)="convertToEmails()">Convert</button>
          </div>
        </div>

        <div fxFlex class="p-8" fxLayout="column" style="overflow: auto;" *ngIf="!importMode">

          <div fxFlex fxLayout="row" *ngFor="let _ of frecipients.controls; index as i;let first = first;let last = last;">
            <ng-container [formGroupName]="i">

              <div fxFlex="80" class="p-4">
                <mat-form-field class="w-100-p">
                  <mat-label>Email</mat-label>
                  <input type="email" matInput formControlName="email" placeholder="Ex. pat@example.com">
                </mat-form-field>
              </div>

              <div fxFlex="20" class="p-4">
                <mat-form-field class="w-100-p">
                  <mat-label>Amount</mat-label>
                  <input type="number" matInput formControlName="amount" placeholder="Amount">
                </mat-form-field>
              </div>

              <div fxFlex="10" fxLayout="row" fxLayoutAlign="end center">
                <button *ngIf="!first" [class]="{'lonesomeDelete': !last}" mat-icon-button (click)="removeReceipt(i)"><i class="mdi mdi-delete-outline"></i></button>
                <button *ngIf="last" mat-icon-button (click)="addAReceipt()"><i class="mdi mdi-plus-circle-outline"></i></button>
              </div>

            </ng-container>
          </div>

        </div>

      </div>

      <div fxFlex="auto" class="fuse-card mt-8" fxLayout="column" id="message" formGroupName="mailGroup">

        <div class="p-16">
          <div class="h1">Message:</div>
        </div>

        <div fxFlex class="p-8">
          <mat-form-field class="w-100-p">
            <mat-label>Subject</mat-label>
            <input type="text" matInput formControlName="subject" placeholder="Mail subject...">
          </mat-form-field>
        </div>

        <div fxFlex class="p-8">
          <mat-form-field class="w-100-p">
            <mat-label>Message</mat-label>
            <textarea matInput placeholder="Add a message for recipient...." formControlName="message" style="min-height:250px"></textarea>
          </mat-form-field>
        </div>

        <div fxFlex="10" class="p-8" fxLayout="row" id="sendToolBar">
          <span fxFlex="grow"></span>
          <button mat-raised-button (click)="reviewCards()">Send !</button>
        </div>

      </div>

      <span fxFlex="grow"></span>

    </ng-container>

  </div>

  <div fxFlex fxLayout="column" *ngIf="dashboardDatas.uxInteractions.sendCard.mode === 'review' || dashboardDatas.uxInteractions.sendCard.mode === 'send'">

    <div fxFlex="auto" fxLayout="row">
      <div fxFlex class="grow">Sending <b>{{dashboardDatas.uxInteractions.sendCard.nbDone}}/{{sendToPayload.length}}</b> TangoCards</div>
      <button [disabled]="dashboardDatas.uxInteractions.sendCard.isSending" mat-button (click)="setState('edit')" class="ml-4">Start again</button>
      <button [disabled]="dashboardDatas.uxInteractions.sendCard.isSending || dashboardDatas.uxInteractions.sendCard.isSent" mat-stroked-button (click)="doSendCards()" class="ml-4">Send Now / process</button>
    </div>

    <div fxFlex="auto" fxLayout="column" class="mt-8" style="overflow: auto;">
      <div fxFlex="auto" fxLayout="column" *ngFor="let payload of dashboardDatas.data.cardsToSend" class="p-4">

        <div fxFlex
             class="message-box"

             [ngClass]="{
             'warning': (payload.isSending),
             'error': (!payload.isSending && payload.error),
             'success': (!payload.isSending && !payload.error && payload.done)
             }"

             fxLayout="row">
          <div fxFlex="80">
            To: {{payload.email}}
          </div>
          <div fxFlex="20">
            {{payload.amount | currency}} {{cardChoosed?.currency || '[No currency?]'}}
          </div>
          <div fxFlex="auto">
            [{{payload.done}}]
          </div>
        </div>

        <div *ngIf="payload.error" fxFlex="auto" style="overflow: auto; height: 150px;">
          <pre>{{payload.result|json}}</pre>
        </div>

      </div>
    </div>

    <div fxFlex="grow" fxLayout="column">
      <div fxFlex="grow"></div>
      <div fxFlex fxLayout="row">
        <div fxFlex class="grow"></div>
        <button [disabled]="dashboardDatas.uxInteractions.sendCard.isSending" mat-button (click)="setState('edit')" class="ml-4">Start again</button>
        <button [disabled]="dashboardDatas.uxInteractions.sendCard.isSending || dashboardDatas.uxInteractions.sendCard.isSent" mat-stroked-button (click)="doSendCards()" class="ml-4">Send Now / process</button>
      </div>
    </div>

  </div>

</ng-container>
